import * as React from "react";
const SvgFiBrandsSass = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g
      fill="#151A2D"
      fillRule="evenodd"
      clipPath="url(#fi-brands-sass_svg__a)"
      clipRule="evenodd"
    >
      <path d="m9.903 16.061-.002-.004.115-.06c.18.645.161 1.248-.026 1.793a3 3 0 0 1-.15.355q-.218.434-.578.808c-.726.76-1.74 1.048-2.176.806-.47-.262-.234-1.334.608-2.189.906-.918 2.21-1.509 2.21-1.509" />
      <path d="M12.5 0C5.597 0 0 5.373 0 12s5.597 12 12.5 12S25 18.627 25 12 19.403 0 12.5 0m4.076 10.64c-2.167.805-3.96.677-4.695.446-.836-.264-1.328-.794-1.447-1.093-.046-.117-.128-.314 0-.382.079-.042.11-.032.321.191.2.211 1.003.78 2.53.615 4.006-.431 6.418-3.419 5.657-5.026-.534-1.125-3.622-1.633-7.478.212C6.755 7.855 6.5 9.712 6.459 10.417c-.11 1.94 2.494 2.961 3.903 4.403q.05.05.096.103c.426-.152 1.017-.238 1.956-.254 2.278-.038 3.565 1.404 3.512 2.693-.042 1.015-1.012 1.434-1.193 1.463-.13.022-.203.025-.22-.074-.013-.068.034-.099.187-.191.154-.091.614-.394.696-.944s-.348-1.864-2.54-2.11c-.778-.087-1.39-.028-1.914.105.38.804.453 2.423-.422 3.675-.906 1.298-2.594 2.088-4.238 1.649-.531-.142-1.332-1.194-.64-2.662.655-1.391 3.455-2.751 3.837-2.932v-.006c-1.297-1.072-4.453-2.518-4.899-4.729-.127-.624.18-2.124 2.098-3.847C8.292 5.31 10.537 4.2 12.61 3.493c3.485-1.188 7.165-.487 7.732 1.643.557 2.096-1.339 4.603-3.765 5.504" />
    </g>
    <defs>
      <clipPath id="fi-brands-sass_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsSass;
